<template>
    <v-list-item>
        <v-list-item-icon>
            <v-icon>mdi-brightness-6</v-icon>
        </v-list-item-icon>
        <v-list-item-action>
            <v-switch v-model="darkMode"/>
        </v-list-item-action>
    </v-list-item>
</template>

<script>
import CookieService from "@/utils/Services/CookieService";

export default {
    name: "DarkMode",
    data() {
        return {
            darkMode: false
        };
    },
    watch:{
        darkMode(value){
            CookieService.set('general','darkmode',value)
            if(value){
                this.$vuetify.theme.dark = true;
            } else {
                this.$vuetify.theme.dark = false;
            }
        }
    },
    created() {
        if(CookieService.get('general','darkmode') === true){
            this.darkMode = true;
        }
    }
}
</script>
